"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const RefetchQueryContext_1 = require("context/RefetchQueryContext");
const ToastContext_1 = require("context/ToastContext");
const useHighlighted_1 = require("hooks/api/useHighlighted");
const HelperUtils_1 = require("utils/HelperUtils");
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const BookmarkToggle = ({ isHighlighted, id, isReadOnly }) => {
    const history = (0, react_router_dom_1.useHistory)();
    const { addToast } = (0, ToastContext_1.useToastContext)();
    const { refetchObjective } = (0, RefetchQueryContext_1.useRefetchQuery)();
    const whenSuccess = () => {
        refetchObjective(id);
        if (!isHighlighted) {
            return addToast({
                msg: [
                    react_1.default.createElement(react_1.default.Fragment, null,
                        (0, HelperUtils_1.getObjectiveLocale)(`You can see all the highlighted goals `),
                        react_1.default.createElement("span", { className: "bold text-base-600 underline cursor-pointer", onClick: () => history.replace({
                                pathname: '/highlighted'
                            }) }, (0, HelperUtils_1.getObjectiveLocale)('here')))
                ],
                title: 'Goal has been highlighted',
                type: 'success'
            });
        }
    };
    const { mutate: submitEdit } = (0, useHighlighted_1.useEditHighlighted)(id, {
        onSuccess: () => __awaiter(void 0, void 0, void 0, function* () {
            whenSuccess();
        })
    });
    const { mutate: submitDelete } = (0, useHighlighted_1.useDeleteHighlighted)(id, {
        onSuccess: () => __awaiter(void 0, void 0, void 0, function* () {
            whenSuccess();
        })
    });
    const onClickHandler = () => __awaiter(void 0, void 0, void 0, function* () {
        if (isReadOnly)
            return;
        isHighlighted ? submitDelete() : submitEdit();
    });
    return (react_1.default.createElement(SVGIcon_1.default, { onClick: onClickHandler, iconName: "icon-bookmark_outline", size: 16, fillColor: `${isHighlighted ? 'var(--n-000)' : 'var(--n-600)'}`, customClass: `bookmarks ${isHighlighted ? 'bg-base-600' : 'bg-n-300'} rounded mr-[8px] ${isReadOnly ? 'cursor-default' : ''}`, dataCy: `bookmark-${id}`, id: `bookmark-${id}` }));
};
exports.default = BookmarkToggle;
